import React from 'react';
import { images } from '../../../../Constants/ImageUrls';
import { BannerPoints, BannerPointsContainer, RightTick } from './styled';

export default function IVFPoints({ formPoints }) {
  const pointList = [
    'High Success Rate up to 70%',
    'Rs10,000 Cashback',
    'More than 50,000 successful IVF procedures done across our partners',
    'Free consultation & Financial Estimate from Top rated IVF hospitals in India',
    'Highly experienced and acclaimed doctors',
    'Best in class Technology',
    'Providing services in 12+ cities in India',
    'Dedicated relationship manager & 24/7 support',
  ];
  const data = formPoints ? formPoints : pointList;
  return (
    <BannerPointsContainer>
      {data?.map((data, index) => {
        return (
          <BannerPoints key={index}>
            <div className="div">
              <RightTick src={images.rightTick} alt="right tick" />
              <p> {data}</p>
            </div>
          </BannerPoints>
        );
      })}
    </BannerPointsContainer>
  );
}
